const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate pseudoContentArrayMapBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const context = await evaluateSource(source.context, content, parentContentPath, transientContext, nativeFunctions);
  const result = [];
  let index;
  for (index = 0; index < values.length; index += 1) {
    const value = values[index];
    const pseudoContent = {
      context,
      index,
      value,
      values
    };
    // eslint-disable-next-line no-await-in-loop
    result.push(await evaluateSource(source.valueTransform, pseudoContent, '', transientContext, nativeFunctions));
  }
  return result;
};
module.exports = {
  evaluate
};